var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintGreenAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7749_144385)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 26,
    height: 26,
    rx: 4,
    fill: "#43AC43"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15C10.7761 15 11 14.7761 11 14.5C11 14.2239 10.7761 14 10.5 14C10.2239 14 10 14.2239 10 14.5C10 14.7761 10.2239 15 10.5 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8C11.8954 8 11 8.89543 11 10V12H10C8.89543 12 8 12.8954 8 14V17C8 18.1046 8.89543 19 10 19H11V20C11 21.1046 11.8954 22 13 22H19C20.1046 22 21 21.1046 21 20V19H22C23.1046 19 24 18.1046 24 17V14C24 12.8954 23.1046 12 22 12H21V10C21 8.89543 20.1046 8 19 8H13ZM12 10C12 9.44772 12.4477 9 13 9H19C19.5523 9 20 9.44772 20 10V12H12V10ZM13 15C11.8954 15 11 15.8954 11 17V18H10C9.44772 18 9 17.5523 9 17V14C9 13.4477 9.44772 13 10 13H22C22.5523 13 23 13.4477 23 14V17C23 17.5523 22.5523 18 22 18H21V17C21 15.8954 20.1046 15 19 15H13ZM20 17V20C20 20.5523 19.5523 21 19 21H13C12.4477 21 12 20.5523 12 20V17C12 16.4477 12.4477 16 13 16H19C19.5523 16 20 16.4477 20 17Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7749_144385",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7749_144385"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7749_144385",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintGreenAction);
export default __webpack_public_path__ + "static/media/print-green-action.7a332fc80df3a92cd43f45225b2ce29e.svg";
export { ForwardRef as ReactComponent };